module.exports = __webpack_public_path__ + "media/images/cleaning/main_image2-a918d3c71c975e07198b8c6e3b593e4e.jpg";